import {Feature} from '~/src/utilities/constants/feature';
import {TeaserTypes} from '~/src/utilities/constants/types';
import {isEnabled} from '~/src/utilities/helpers/feature';
import {AdFormat} from '../constants/formats';
import {createFormat, StyleFormat} from '../feed/format';

type FeatureTeaserProps = {
    type: string;
};

type SideAdProps = {
    type: string;
    adUnitName: string;
    format: StyleFormat;
    availableFor: {};
};

const featureMap = {
    [Feature.MOST_COMMENTED]: {type: TeaserTypes.WIDGET_MOST_COMMENTED},
    [Feature.RECENTLY_COMMENTED]: {type: TeaserTypes.WIDGET_RECENTLY_COMMENTED}
};

const featureEnabled = (feature: string) => (isEnabled(feature) ? featureMap[feature] : null);

const validate = (sidelineType: string) => {
    switch (sidelineType) {
        case Feature.MOST_COMMENTED:
        case Feature.RECENTLY_COMMENTED:
            return featureEnabled(sidelineType);
        default:
            return null;
    }
};

const sidelineStackKeys = [Feature.MOST_COMMENTED, Feature.RECENTLY_COMMENTED];

const createSidelineStack = (input: string[]) => {
    const stack = input.filter((feature) => isEnabled(feature));

    return stack.map(validate).filter(Boolean) as FeatureTeaserProps[];
};

const defaultSideline = {
    type: TeaserTypes.AD,
    format: createFormat(AdFormat.INSIDE_QUARTER_POS),
    availableFor: {desktop: true}
};

export type GetNextSideline = (adUnitName: string) => FeatureTeaserProps;

type SidelineStack = () => GetNextSideline;
export const sidelineStack: SidelineStack = () => {
    const stack = createSidelineStack(sidelineStackKeys);
    let iteration = 0;

    const getNextSideline: GetNextSideline = (adUnitName: string) => {
        if (++iteration % 2 && stack.length) {
            return stack.pop() as FeatureTeaserProps;
        }

        return {
            ...defaultSideline,
            adUnitName
        };
    };

    return getNextSideline;
};
